import { Button, OutlinedInput, Typography } from '@mui/material';
import './styles.css'
import { useState } from 'react';
import { sxInput, sxLabel } from './sxProps';
import { sxButton } from '../sxProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { ProtocolStepProps } from '../../../../interfaces/props/Financeiro/Reembolso/ProtocolStepProps';

function ProtocolStep(props: ProtocolStepProps) {
    const [protocol, setProtocol] = useState<string>('');
    const navigate = useNavigate();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setProtocol(event.target.value);
    }

    const goBack = () => {
        navigate(-1)
    }

    const handleConfirm = () => {
        props.handleProtocolStep(protocol)
    }
    
    return (
        <div className="protocol-step-holder">
            <div className="protocol-step-header">
                <h1 className="protocol-step-title">Reembolso</h1>
                <p className="protocol-step-instruction">Caso tenha entrado em contato com nossa equipe anteriormente sobre reembolso, informe o protocolo de atendimento.</p>
            </div>
            <div className="protocol-step-content">
                <div className="protocol-step-info">
                    <Typography sx={sxLabel}>Protocolo</Typography>
                    <label htmlFor="protocoloInput" aria-label="protocolo" />
                    <OutlinedInput
                        fullWidth
                        id="protocoloInput"
                        type={'number'}
                        placeholder='Exemplo: 1234567'
                        value={protocol}
                        onChange={handleChange}
                        name='email'
                        maxRows={1}
                        inputProps={{ maxLength: 30 }}
                        sx={sxInput}
                    />
                </div>
                <div className="first-step-contact-buttons">
                    <div className="first-step-contact-button">
                        <Button 
                            variant="contained" 
                            type='submit'
                            sx={sxButton}
                            disabled={false}
                            onClick={handleConfirm}
                            fullWidth>
                            Confirmar
                        </Button>
                    </div>
                </div>
                <button className="back-button" onClick={goBack} aria-label="Voltar para o menu de reembolso">
                    <FontAwesomeIcon icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
                </button>
            </div>
        </div>
    )
}

export default ProtocolStep;